import { userSession } from '@/api/modules/login.api.js';
import appAPI, { currentDomainOrganisation } from '@/api/modules/app.api.js';
import Config from '@/services/config.service';
const appConfig = new Config();

export default [
  {
    path: 'accounts/organisations',
    name: 'Organisations',
    component: () => import('@/app/organisation/views/Organisations.vue'),
    beforeEnter: async (to, from, next) => {
      if (appConfig.isSaas && !currentDomainOrganisation.value) {
        await appAPI.getCurrentDomainOrganisation();
      }
      if (!userSession.isSuperuser() && appConfig.isSaas && currentDomainOrganisation.value) {
        return next({
          name: 'OrganisationDetail',
          params: {
            locale: to.params.locale,
            id: String(currentDomainOrganisation.value.id),
          },
        });
      } else {
        return next();
      }
    },
  },
  {
    path: 'accounts/organisations/new',
    name: 'AddOrganisation',
    component: () => import('@/app/organisation/views/AddOrganisation.vue'),
    beforeEnter: (to, from, next) => {
      if (!userSession.isSuperuser() && appConfig.isSaas) {
        return next({
          name: 'Accounts',
          params: {
            locale: to.params.locale,
          },
        });
      }
      return next();
    },
  },
  {
    path: 'accounts/organisations/:id',
    name: 'OrganisationDetail',
    component: () => import('@/app/organisation/views/OrganisationDetail.vue'),
  },
];
